import { render, staticRenderFns } from "./AlLink.vue?vue&type=template&id=69b12574&scoped=true&"
import script from "./AlLink.vue?vue&type=script&lang=js&"
export * from "./AlLink.vue?vue&type=script&lang=js&"
import style0 from "./AlLink.vue?vue&type=style&index=0&id=69b12574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b12574",
  null
  
)

export default component.exports